"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMetricsLink = void 0;
var client_1 = require("@apollo/client");
var atoz_shiftapp_metrics_1 = require("@amzn/atoz-shiftapp-metrics");
var createMetricsLink = function () {
    return new client_1.ApolloLink(function (operation, forward) {
        var _a;
        // time when request is sent
        operation.setContext({ start: performance.now() });
        // GQL request start count metric
        atoz_shiftapp_metrics_1.logger.emitCountMetric({
            metricName: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_START,
            dimensions: (_a = {},
                _a[atoz_shiftapp_metrics_1.DIMENSION_NAME.GQL_OPERATION_NAME] = operation.operationName,
                _a)
        });
        return forward(operation).map(function (data) {
            var _a, _b;
            var time = performance.now() - operation.getContext().start;
            // GQL request completed count metric
            atoz_shiftapp_metrics_1.logger.emitCountMetric({
                metricName: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_COMPLETE,
                dimensions: (_a = {},
                    _a[atoz_shiftapp_metrics_1.DIMENSION_NAME.GQL_OPERATION_NAME] = operation.operationName,
                    _a)
            });
            // GQL request round trip latency metric
            atoz_shiftapp_metrics_1.logger.emitLatencyMetric({
                metricName: atoz_shiftapp_metrics_1.METRIC_NAME.GQL_LATENCY,
                metricValue: time,
                dimensions: (_b = {},
                    _b[atoz_shiftapp_metrics_1.DIMENSION_NAME.GQL_OPERATION_NAME] = operation.operationName,
                    _b)
            });
            return data;
        });
    });
};
exports.createMetricsLink = createMetricsLink;
